import { Field, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';
import { KeyValuePair } from 'src/shared/shared.types';

export type C48ReputationScheduleCTAFields = {
  ButtonText?: Field<string>;
  ErrorMessage?: RichTextField;
  FilterText?: Field<string>;
  FilterType?: KeyValuePair;
  Headline?: Field<string>;
  Icon?: KeyValuePair;
  InputLabel?: Field<string>;
  PlaceholderText?: Field<string>;
  SearchType?: KeyValuePair;
  SupportCopy?: RichTextField;
};

export type C48ReputationScheduleCTAParams = {
  ExcludeFromTranslation?: boolean;
  HeadlineTag?: string;
  TopBorderColor?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams;

export type C48ReputationScheduleCTAProps = RenderingProps<
  C48ReputationScheduleCTAFields,
  C48ReputationScheduleCTAParams
>;
